import React from 'react';
import { Layout } from '../components/layout/Layout';
import { SEO } from '../components/shared/SEO';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-black uppercase tracking-wide text-white mb-4 pb-2 border-b border-slate-700">
      {title}
    </h2>
    <div className="text-slate-300 text-sm leading-relaxed space-y-3">
      {children}
    </div>
  </div>
);

const TermsPage = () => {
  const updated = 'April 13, 2026';

  return (
    <Layout>
      <SEO
        title="Terms & Conditions | AAA Irrigation Service"
        description="Terms and conditions for AAA Irrigation Service, including SMS / text messaging terms."
      />

      <div className="bg-[#0f172a] min-h-screen py-16 px-4">
        <div className="max-w-3xl mx-auto">

          <h1 className="text-3xl font-black uppercase italic tracking-wide text-white mb-2">
            Terms &amp; Conditions
          </h1>
          <p className="text-slate-500 text-sm mb-10">Last updated: {updated}</p>

          <Section title="Agreement">
            <p>
              By using the services, website, or communications of AAA Irrigation Service LLC
              ("Company," "we," "us"), you agree to these Terms &amp; Conditions. If you do not
              agree, please do not use our services.
            </p>
          </Section>

          <Section title="Services">
            <p>
              AAA Irrigation Service provides residential and commercial irrigation installation,
              repair, backflow preventer installation, and seasonal maintenance services in the North Texas area.
              Service availability is subject to scheduling and geographic coverage.
            </p>
            <p>
              All estimates are provided on-site or via written quote. Pricing is subject to change
              without notice until a written agreement is executed.
            </p>
          </Section>

          <Section title="SMS / Text Messaging Terms">
            <p>
              <strong className="text-white">Program:</strong> By providing your mobile phone number
              and consenting, you agree to receive SMS text messages from AAA Irrigation Service
              related to appointment confirmations, service reminders, estimate notifications, job
              status updates, and two-way customer support conversations.
            </p>
            <p>
              <strong className="text-white">Consent:</strong> Your consent to receive SMS messages
              is not a condition of purchase or service. You may opt out at any time.
            </p>
            <p>
              <strong className="text-white">Message Frequency:</strong> Message frequency may vary
              based on your service activity. You may receive messages related to scheduling,
              technician dispatch, or follow-up communication.
            </p>
            <p>
              <strong className="text-white">Rates:</strong> Standard message and data rates may
              apply depending on your carrier and plan.
            </p>
            <p>
              <strong className="text-white">Opt-Out:</strong> Reply <span className="font-mono text-[#ea580c]">STOP</span> to
              any text message at any time to unsubscribe. You will receive a confirmation and no
              further messages will be sent. Text <span className="font-mono text-[#ea580c]">START</span> to
              re-subscribe.
            </p>
            <p>
              <strong className="text-white">Help:</strong> Reply <span className="font-mono text-[#ea580c]">HELP</span> for
              assistance, or contact us at{' '}
              <a href="tel:4697513567" className="text-[#1b7abf] hover:underline">(469) 751-3567</a> or{' '}
              <a href="mailto:info@aaairrigationservice.com" className="text-[#1b7abf] hover:underline">
                info@aaairrigationservice.com
              </a>.
            </p>
            <p>
              <strong className="text-white">Data:</strong> No mobile phone numbers or SMS consent
              information will be shared with third parties or affiliates for marketing or
              promotional purposes. All data categories exclude text messaging originator opt-in
              data and consent; this information will not be shared with any third parties. See our{' '}
              <Link to="/privacy" className="text-[#1b7abf] hover:underline">Privacy Policy</Link> for
              full details.
            </p>
          </Section>

          <Section title="Limitation of Liability">
            <p>
              AAA Irrigation Service shall not be liable for indirect, incidental, or consequential
              damages arising from the use of our services. Our liability is limited to the value of
              services rendered under the applicable service agreement.
            </p>
          </Section>

          <Section title="Governing Law">
            <p>
              These terms are governed by the laws of the State of Texas. Any disputes shall be
              resolved in Collin County, Texas.
            </p>
          </Section>

          <Section title="Changes to These Terms">
            <p>
              We may update these Terms &amp; Conditions at any time. Continued use of our services
              after changes constitutes acceptance of the revised terms.
            </p>
          </Section>

          <Section title="Contact">
            <p>
              AAA Irrigation Service LLC<br />
              Plano / Allen, TX<br />
              Phone: <a href="tel:4697513567" className="text-[#1b7abf] hover:underline">(469) 751-3567</a><br />
              Email: <a href="mailto:info@aaairrigationservice.com" className="text-[#1b7abf] hover:underline">
                info@aaairrigationservice.com
              </a>
            </p>
          </Section>

        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;
